import Joi from 'joi';

import Button from '../../themed/button';
import Form from '../../common/form';

import { func, object } from 'prop-types';
import { getResultOptions } from '../../../utils/data';
import { CoverDataItem } from '../../../utils/models';

class EditLPTReportItemForm extends Form {
	state = {
		data: initialData,
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		joint: Joi.string().min(3).required().label('Joint/Job Number'),
		observation: Joi.string().min(10).required().label('Observation'),
		result: Joi.string().min(3).required().label('Result'),
		images: Joi.array().min(1).required().label('Image'),
	};

	static propTypes = {
		onAdd: func,
		initialData: object,
		onCancelEdit: func,
		onEdit: func,
	};

	componentDidMount() {
		if (this.props.initialData) {
			const imageIDs = this.props.initialData.images.map(
				(image: CoverDataItem) => +image.value
			);
			const images = this.props.photoNumbers.filter((item: CoverDataItem) =>
				imageIDs.includes(item.value)
			);

			this.setState({ data: { ...this.props.initialData, images } });
		}
	}

	doSubmit = (): void => {
		this.props.onEdit(this.state.data);
		this.setState({ data: initialData });
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<h3 className="form-title">Update Inspected Item</h3>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'joint',
							label: 'Joint/Job Number',
							placeholder: 'Enter Joint/Job Number',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'observation',
							label: 'Observation',
							placeholder: 'Enter your Observation',
						})}
					</div>

					<div className="col">
						{this.renderSelect({
							name: 'result',
							label: 'Result.',
							placeholder: 'Select Result',
							options: getResultOptions(),
						})}
					</div>

					<div className="col">
						{this.renderCreatableMultiselect({
							closeMenuOnSelect: true,
							options: this.props.photoNumbers,
							name: 'images',
							placeholder: 'Select Photo Number',
							label: 'Photo Number',
							isMulti: true,
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Update Item')}

					<div className="mx-4">
						<Button
							label="Cancel"
							style={{ backgroundColor: 'red' }}
							onClick={this.props.onCancelEdit}
						/>
					</div>
				</div>
			</form>
		);
	}
}

const initialData = {
	joint: '',
	observation: '',
	result: '',
	images: [],
};

export default EditLPTReportItemForm;
